import { CurrencyNumberPipe } from '../../../../infrastructure/shared/pipes/currency-number.pipe';
import { Component, computed, input, model, output } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { IndividualPackageDto } from '../../../../infrastructure/shared/model/fss.api';
import {
  ButtonComponent,
  ButtonSeverity,
  ButtonSize,
} from '../../../../infrastructure/shared/ui/button/button';
import { Cube01 } from '../../../../infrastructure/shared/icons/cube-01/cube-01';
import { XClose } from '../../../../infrastructure/shared/icons/x-close/x-close';
import { CheckCircle } from '../../../../infrastructure/shared/icons/check-circle/check-circle';
import { getIndividualPackageName } from '../individual-package-naming';

@Component({
  standalone: true,
  selector: 'app-individual-buy-package-dialog',
  imports: [
    Dialog,
    CurrencyNumberPipe,
    ButtonComponent,
    Cube01,
    XClose,
    CheckCircle,
  ],
  templateUrl: './individual-buy-package-dialog.html',
  styleUrl: './individual-buy-package-dialog.scss',
})
export class IndividualBuyPackageDialog {
  isVisible = model.required<boolean>();
  pkg = input.required<IndividualPackageDto>();
  confirmed = output<void>();

  protected packageName = computed(() => getIndividualPackageName(this.pkg()?.hours ?? 0));

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;

  onConfirm(): void {
    this.confirmed.emit();
    this.isVisible.set(false);
  }

  onCancel(): void {
    this.isVisible.set(false);
  }
}
